import { render } from "./inviteDoctor.vue?vue&type=template&id=952b6cb2"
import script from "./inviteDoctor.vue?vue&type=script&lang=js"
export * from "./inviteDoctor.vue?vue&type=script&lang=js"

import "./inviteDoctor.vue?vue&type=style&index=0&id=952b6cb2&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__